import React from "react";

const HIGHLIGHT_TEXT =
  "a refund of the order total minus non-refundable payment processing fees will be issued";

function splitWithHighlight(text, needle) {
  const source = String(text || "");
  const query = String(needle || "");
  if (!source || !query) return [source];

  const sourceLower = source.toLowerCase();
  const queryLower = query.toLowerCase();
  const parts = [];
  let cursor = 0;

  while (cursor < source.length) {
    const matchIndex = sourceLower.indexOf(queryLower, cursor);
    if (matchIndex === -1) {
      parts.push(source.slice(cursor));
      break;
    }

    if (matchIndex > cursor) {
      parts.push(source.slice(cursor, matchIndex));
    }

    parts.push({
      highlighted: true,
      text: source.slice(matchIndex, matchIndex + query.length),
    });
    cursor = matchIndex + query.length;
  }

  return parts;
}

function PolicyTextWithFeeHighlight({ text, className }) {
  const chunks = splitWithHighlight(text, HIGHLIGHT_TEXT);

  return (
    <p className={className} style={{ whiteSpace: "pre-line" }}>
      {chunks.map((chunk, index) => {
        if (typeof chunk === "string") {
          return <React.Fragment key={`plain-${index}`}>{chunk}</React.Fragment>;
        }

        return (
          <span key={`highlight-${index}`} style={{ color: "#dc2626", fontWeight: 600 }}>
            {chunk.text}
          </span>
        );
      })}
    </p>
  );
}

export default PolicyTextWithFeeHighlight;
